module.exports = __webpack_public_path__ + "c502cc32afaf0eb643b6e0eb9087680e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-panel-420.jpg
// module id = 378
// module chunks = 0